import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12C/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12C/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12C/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12C/4.jpg';

// import p5 from 'assests/Photos/ClassAssembly/2024/12A/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12A/6.jpg';
// import p7 from 'assests/Photos/ClassAssembly/2024/12A/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
// import CoScholacticSidebar2025 from '../CoScholacticSidebar2025';
import { Sidebar2025 } from '../SEWA/components';
import Archive_2022 from '../CurricularClass52023/Archive_2022';


const OrphangeVisit2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/1.webp`;
const p2 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/2.webp`;
const p3 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/3.webp`;
const p4 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/4.webp`;
const p5 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/5.webp`;
const p6 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/6.webp`;
const p7 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/7.webp`;
const p8 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/8.webp`;
const p9 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/9.webp`;
const p10 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/10.webp`;
const p11 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/11.webp`;
const p12 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/12.webp`;
const p13 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/13.webp`;
const p14 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/Orphange/14.webp`;


  

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
},
{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
},
{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
},
{
    src: p13,
    source: p13,
    rows: 1,
    cols: 1,
},
{
    src: p14,
    source: p14,
    rows: 1,
    cols: 1,
}



  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      VISIT TO ORPHANAGE
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class : 9                 Date: 17 October 2025

        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Tell me and I forget, teach me and I may remember, involve me and I learn. – Benjamin Franklin”

<br/>
        </Typography> */}

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
       Students of Class 9 visited three centres of ‘Need Base India’ orphanage on 17th October 2025 as part of the school’s community outreach programme. They were privileged to engage in a profoundly enriching experience through their visit to an orphanage, where they had the opportunity to interact, converse and share joyful moments with the children in a spirit of empathy and connection. 
       <br></br>
        The students spent quality time with the children. They happily distributed snacks, sports equipment and handcrafted items like notebooks, diaries, pen stands and bookmarks, each thoughtfully created to bring joy and utility to the children. The experience served as a powerful reminder that privilege is not something everyone enjoys equally and with that awareness comes a responsibility to support and uplift those facing greater challenges. They also entertained the children with a variety of games and enjoyable activities. The highlight of the day was a delightful performance by the orphanage children, which beautifully showcased their exceptional talent and creativity.
        <br></br>
        Interacting with children who have different life experiences helped students develop a deeper understanding and appreciation for others The experience provided a powerful lesson about the realities of life, showing students, that happiness is often found in small things and relationships, rather than just material possessions. 
        <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “The greatest good is what we do for one another”

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 250 : 350}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <Sidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default OrphangeVisit2025;